export default class OperacaoFiscal {
  modeloDocumento = null;
  movimentacaoFinanceira = null;
  naturezaOperacao = null;
  movimentacaoEstoque = null;
  tipoOperacao = null;
  finalidade = null;
  naoGerarComissao = null;
  planoFinanceiroId = null;
  centroCustoId = null;

  constructor(operacaoFiscal) {
    this.modeloDocumento = operacaoFiscal.modeloDocumento;
    this.movimentacaoFinanceira = operacaoFiscal.movimentacaoFinanceira;
    this.movimentacaoEstoque = operacaoFiscal.movimentacaoEstoque;
    this.tipoOperacao = operacaoFiscal.tipoOperacao;
    this.finalidade = operacaoFiscal.finalidade;
    this.naturezaOperacao = operacaoFiscal.naturezaOperacao;
    this.naoGerarComissao = operacaoFiscal.naoGerarComissao;
    this.planoFinanceiroId = operacaoFiscal.planoFinanceiroId;
    this.centroCustoId = operacaoFiscal.centroCustoId;
  }
}
